export const directDebitCommand = {
  export: 'exportDirectDebit',
  openInvoice: 'openInvoice',
};
